import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid, CircularProgress, Box, Tooltip, MenuItem, Select } from '@mui/material';
import { Secondary } from '../CustomButton';
import { Primary } from 'ui-components/Buttons';
import { useTheme } from '@emotion/react';
import CustomInputField from 'ui-components/CustomInputField';
import { amountInWords, currencyInputProps, formatAllowsNegativeCurrency } from 'utilities/index';
import { FetchAllCurrencyLists } from 'api/utils';

const ConfirmationDialog = ({ open, handleClose, handleSubmission, heading, subheading, ActionText, isLoading, hasFields = false }) => {
    const theme = useTheme();
    const { data: currencyList, isLoading: isLoadingCurrency } = FetchAllCurrencyLists();
    const [interestedAmount, setInterestedAmount] = React.useState(0);
    const [currencyIcon, setCurrencyIcon] = React.useState("₹");
    const [currencyId, setCurrencyId] = React.useState(null);

    React.useEffect(() => {
        if (currencyList && currencyList.length > 0) {
            setCurrencyIcon(currencyList[0].code);
            setCurrencyId(currencyList[0]._id);
        }
    }, [currencyList]);

    // console.log(currencyIcon, currencyId, "currencyList")

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="delete-confirmation-dialog" sx={{
            minWidth: 300, "& > .MuiDialog-container > .MuiPaper-root": {
                borderRadius: "20px"
            }
        }}>
            <DialogTitle id="delete-confirmation-dialog" sx={{ textAlign: 'center', fontWeight: 700, fontSize: '1.5rem', color: theme.palette.customColors.g300 }}>
                {heading ? heading : "Confirm Deletion"}
            </DialogTitle>
            <DialogContent sx={{ padding: "10px 24px" }}>
                <Grid container justifyContent="center">
                    <Typography sx={{ fontSize: '1rem', color: theme.palette.customColors.g200, textAlign: 'center' }}>
                        {subheading ? subheading : 'Are you sure you want to delete this item? This action cannot be undone.'}
                    </Typography>
                    {hasFields && <Tooltip title={amountInWords(interestedAmount, currencyIcon)}>
                        <CustomInputField
                            name="interestedAmount"
                            label={""}
                            value={formatAllowsNegativeCurrency(interestedAmount, currencyIcon == "₹" ? "en-IN" : "en-US")?.replaceAll("--", "")}
                            onChange={(e) => {
                                setInterestedAmount(formatAllowsNegativeCurrency(e.target.value, currencyIcon == "₹" ? "en-IN" : "en-US")?.replaceAll("--", ""))
                            }}
                            InputProps={{
                                // startAdornment: Adornment
                                ...currencyInputProps,
                                startAdornment: (
                                    <Box pl={2} mr={-1}>{(currencyIcon)}</Box>
                                ),
                                endAdornment: (
                                    !isLoadingCurrency && currencyList && <Select
                                        className="selecttt"
                                        sx={{
                                            "::before": { border: "none !important" },
                                            border: "none !important",
                                            '& >  .MuiSelect-select': {
                                                paddingRight: "2rem !important"
                                            }
                                        }}
                                        value={currencyId}
                                        onChange={(e) => {
                                            // console.log(currencyList?.find(item => item?._id === e.target.value),"edefe")
                                            // formik.setFieldValue(
                                            //     "currency",
                                            //     currencyList?.find(item => item?._id === e.target.value)?.code
                                            // );
                                            setCurrencyIcon(currencyList?.find(item => item?._id === e.target.value)?.code)
                                            setCurrencyId(e.target.value)
                                        }
                                        }
                                    >
                                        {/* <MenuItem value={"$"}>USD</MenuItem>
                                  {<MenuItem value={"₹"}>INR</MenuItem>} */}
                                        {currencyList?.map((item) => (
                                            <MenuItem type="button" value={item?._id}>
                                                {item?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                ),
                            }}
                            sx={{ marginTop: '1rem' }}
                        />
                    </Tooltip>}
                </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', padding: '1rem 1.5rem' }}>
                <Secondary onClick={handleClose} fullWidth sx={{ padding: '0.75rem 1.25rem', fontSize: '1rem', marginRight: '1rem', backgroundColor: theme.palette.customColors.grey, borderWidth: '1px !important' }}>
                    Cancel
                </Secondary>
                <Primary
                    onClick={() => {
                        hasFields ? handleSubmission(currencyId, String(interestedAmount)?.replaceAll(",", "")) : handleSubmission()
                    }}
                    fullWidth
                    sx={{ padding: '0.75rem 1.25rem', fontSize: '1rem', backgroundColor: theme.palette.customColors.red, height: "52px" }}
                    disabled={isLoading}
                >
                    {isLoading ? <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size={'1.2rem'} /> : ActionText ? ActionText : "Delete"}
                </Primary>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
